import React, { useEffect, useRef } from 'react'
import { Spin } from 'antd'

type LoadMoreOnScrollProps = {
    hasMore: boolean
    loading: boolean
    onLoad: () => void
}

// Put at the end of a scrolling list. Loads the next page when it scrolls into view.
export function LoadMoreOnScroll({ hasMore, loading, onLoad }: LoadMoreOnScrollProps) {
    const sentinel = useRef<HTMLDivElement>(null)
    const load = useRef(onLoad)
    load.current = onLoad

    // A new observer after each page also loads the next page when the list does not fill its container yet.
    useEffect(() => {
        if (!hasMore || loading || !sentinel.current) return
        const observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) load.current()
        })
        observer.observe(sentinel.current)
        return () => observer.disconnect()
    }, [hasMore, loading])

    if (!hasMore) return null
    return (
        // A plain div: an empty antd Flex is hidden, and a hidden element is never observed.
        <div
            ref={sentinel}
            className="flex min-h-6 justify-center py-2"
        >
            {loading && <Spin size="small" />}
        </div>
    )
}
